import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de la compra recibís un email con el link de descarga. Los archivos son PDF de alta resolución, listos para imprimir en A4 o leer en pantalla.'
}, {
  q: '¿Sirve si soy profe nuevo o si tengo mucha experiencia?',
  a: 'Sirve para los dos perfiles. Si empezás: el sistema te da estructura desde el primer día. Si ya tenés experiencia: te ahorra horas de planificación y te da material para los niveles más complejos.'
}, {
  q: '¿Los 6 Bonus están en las dos opciones?',
  a: 'Sí. Los 6 Bonus están incluidos tanto en el Pack Profesional como en el Megapack Élite. La diferencia son los 2 Ebooks Élite (Planificador Anual y Entrenamiento para Competencia) que solo vienen en el Megapack.'
}, {
  q: '¿Qué diferencia hay con otros materiales que ya existen?',
  a: 'Natación 360 está diseñado específicamente para la realidad del profe argentino: piletas de 12 a 25 metros, materiales básicos, grupos heterogéneos y el contexto cultural local. No es traducido ni adaptado de otro país. Es 100% argentino.'
}, {
  q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
  a: 'Sí. El Tomo 12 y el Bonus 5 (Kit de Supervivencia) están diseñados específicamente para grupos mixtos. Además el Bonus 1 (Escáner de Niveles) te ayuda a dividir y trabajar cada nivel de forma autónoma.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si dentro de los 7 días de la compra sentís que no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas.'
}, {
  q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
  a: "Especialmente para vos. El Planificador Anual te da la hoja de ruta de los 12 meses para que no pienses más en 'qué sigue'. Y el Manual de Competencia te abre la puerta a un perfil profesional más alto y mejor remunerado. Por $9.000 más no hay argumento en contra."
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago. El pago es 100% seguro.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-gray-50" data-id="element-105">
      <div className="max-w-3xl mx-auto px-4" data-id="element-106">
        <div className="text-center mb-12" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-108">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-109">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-110">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-111">
                <span className="font-bold text-gray-900 pr-4" data-id="element-112">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-blue flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-113" />
              </button>
              <AnimatePresence data-id="element-114">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-115">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-116">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}